import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../Config";
// import { MdModeEdit } from "react-icons/md";
// import { IoMdEye } from "react-icons/io";
// import { IoMdMore } from "react-icons/io";
import moment from "moment";
import { BsBank2 } from "react-icons/bs";
import { GiBanknote } from "react-icons/gi";
import { RiBankCardFill } from "react-icons/ri";
import { MdOutlineQrCodeScanner } from "react-icons/md";
// import { FaArrowDown } from "react-icons/fa";
import { getModeName } from "../../helpers";
// import { FaArrowDown } from "react-icons/fa";
import { GoDownload } from "react-icons/go";


const Table = ({
  ApiData,
  // setSelectedData,
  // setEditUser,
  // setViewDetail,
  // userType,
}) => {
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      // action: "",
    },
  ]);

  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  // const [previousId, setPreviousId] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  // const [openActionMenu, setOpenActionMenu] = useState(null);
  
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };


  useEffect(() => {
    if (ApiData) {
      const tempData = ApiData.map((item) => ({
        tenantName: tenantName(item),
        // tenant: item.tenantName,
        collectionDate: moment(item.collectionDate).format("DD-MMM-YY, HH:mm:ss"),
        amount: getAmount(item.amount),
        mode: getMode(item),
        transactionFor: getTransactionFor(item.transactionFor),
        // receipt:download(item.receipt),
        receipt: DownloadBtn(item),
        clientName: clientpropName(item),
        tenantMobile: item.tenantMobile,
        // status: getStatus(item.status),
        // action: ActionBtns(item),
      }));
      setData(tempData);
    }
  }, [ApiData]);

  const tenantName = (item) => {
    return (
      <div className="flex flex-col gap-[2px]">
        <UserImageWrapper>
          <UserImage src={Images.Avatar} alt={`Avatar for ${item.tenantName}`} />
          <div className="flex flex-col gap-1">
            <span className="text-zinc-900 font-medium">
              {item.tenantName}{" "}
            </span>
            <span className="text-amber-500 text-xs">#{item.tenantMobile}</span>
          </div>
        </UserImageWrapper>
      </div>
    );
  };
  const clientpropName = (item) => {
    return (
      <div className="flex flex-col gap-[2px]">
        <div className="flex flex-col gap-1">
          <span className="text-zinc-600 font-medium">
            {item.propName}{" "}
          </span>
          <span className="text-zinc-500 text-xs">{item.clientName}</span>
        </div>

      </div>
    );
  };
  const getTransactionFor = (transactionFor) => {
    if (transactionFor === 0) {
      return (
        <div className="flex items-center gap-2">
          <h2>Initial Settlement</h2>
        </div>
      );
    } else if (transactionFor === 1) {
      return (
        <div className="flex items-center gap-2">
          <h2>RENT</h2>
        </div>
      );
    } else if (transactionFor === 2) {
      return (
        <div className="flex items-center gap-2">
          <h2>SECURITY</h2>
        </div>
      );
    } else if (transactionFor === 3) {
      return (
        <div className="flex items-center gap-2">
          <h2>MAINTENANCE</h2>

        </div>
      );
    } else if (transactionFor === 4) {
      return (
        <div className="flex items-center gap-2">
          <h2>ELECTRICITY</h2>

        </div>
      );
    } else if (transactionFor === 5) {
      return (
        <div className="flex items-center gap-2">
          <h2>REGISTRATION</h2>

        </div>
      );
    } else if (transactionFor === 6) {
      return (
        <div className="flex items-center gap-2">
          <h2>TECH_CHARGES</h2>

        </div>
      );
    } else if (transactionFor === 7) {
      return (
        <div className="flex items-center gap-2">
          <h2>OTHER</h2>

        </div>
      );
    } else if (transactionFor === 8) {
      return (
        <div className="flex items-center gap-2">
          <h2>AGREEMENT_CHARGE</h2>

        </div>
      );
    } else if (transactionFor === 9) {
      return (
        <div className="flex items-center gap-2">
          <h2>FOOD</h2>

        </div>
      );
    } else if (transactionFor === 10) {
      return (
        <div className="flex items-center gap-2">
          <h2>FINE</h2>

        </div>
      );
    }
  };

  const getMode = (item) => {
    return (
      <div className="flex flex-col gap-1">
        <span className="text-gray-600 font-medium">
          {getModeName(item.mode)}
        </span>
        {/* {item.recordedBy &&
            <span className="text-gray-400 text-xs">{"Recoded By " + item.recordedBy}</span>
            } */}
        {item.recordedBy && (
          <span className={`text-xs ${item.recordedBy === 'Kipinn App' ? 'text-blue-500' : 'text-gray-400'}`}>
            {"Recorded By " + item.recordedBy}
          </span>
        )}
      </div>
    );
  };

  const getAmount = (item) => {
    return <p className="p-3 text-sm md:p-3 text-left">₹{item}</p>;
  };


  const download = (receipt) => {
    window.open(receipt, "_blank");
  };
  const DownloadBtn = (item) => {
    return (
      <div className="flex gap-4 ">
        <button
          onClick={() => download(item.receipt)}
        >
          <GoDownload size={16} />
        </button>
      </div>
    );
  };


  // const getTransactionFor = (item) => {
  //   if (item.transactionFor === 1) {
  //     return "Rent";
  //   } else if (item.transactionFor === 2) {
  //     return "Security";
  //   } else if (item.transactionFor === 3) {
  //     return "Extra Charge";
  //   } else if (item.transactionFor === 4) {
  //     return "Other";
  //   } else {
  //     return "Dues Settlement";
  //   }
  // };

  // const getStatus = (status) => {
  //   if (status === 1) {
  //     return <Pending>Pending</Pending>;
  //   } else if (status === 2) {
  //     return <Resolve>SUCCESS</Resolve>;
  //   } else {
  //     return <Inprogress>FAILED</Inprogress>;
  //   }
  // };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Owner Name",
          accessor: "tenantName",
        },
        {
          Header: "Amount",
          accessor: "amount",
        },
      ];
    }
    return [
      {
        Header: "Tenant",
        accessor: "tenantName",
        // accessor: "tenantMobile"
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
      {
        Header: "Property/Client",
        accessor: "clientName",
      },

      {
        Header: "Desc",
        accessor: "transactionFor",
      },

      // {
      //   Header: "Status",
      //   accessor: "status",
      // },
      {
        Header: "Mode",
        accessor: "mode",
      },
      {
        Header: "Date",
        accessor: "collectionDate",
      },
      {
        Header: "receipt",
        accessor: "receipt",
      },

    ];
  }, [isMobileView]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    // setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );



  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasData={ApiData?.length > 0}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr {...row.getRowProps()} hasData={ApiData?.length > 0}>
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Transaction:</strong>{" "}
                          {data[rowIndex].transactionFor}
                        </li>
                        <li className="flex gap-2">
                          <strong>Status:</strong> {data[rowIndex].status}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-medium cursor-pointer hover:bg-gray-100`;
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
// const ActionBtnWrapper = tw.div`grid xl:grid-cols-2 md:grid-cols-1 grid-cols-4 w-40 mb-1 gap-y-1 gap-x-1.5 md:w-16 mt-3 md:mt-0`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${(props) => (props.hasData ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasData
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
// const Btn = tw.button`grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
// const Pending = tw.div`bg-blue-100 text-blue-700 text-xs border-blue-300 border w-24 h-7 flex items-center justify-center rounded`;
// const Inprogress = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded`;
// const Resolve = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded`;

const UserImageWrapper = tw.div` flex items-center gap-2`;
const UserImage = tw.img`w-9 h-9 rounded-full `;

export default Table;
